import { emailResponseTimeDefaultVal } from "../../../common/shared";
import { IHelpCenterComponent } from "../interfaces/HelpCenterComponent";

const HelpCenterComponentDefaults: Partial<IHelpCenterComponent> = {
  helpCenterNames: [],
  gladlyNewHelpCenters: [],
  helpCenterName: '',
  gladlyPropertyMap: {},
  helpCenterCDNResponse: {},
  gladlyAnswersList: [],
  showLeftHandNavigation: false,
  showContactUsPage: true,
  quickTools: [],
  relatedLinksConfig: {},
  showContactUsOnPage: {},
  helpCenterNumbers: {},
  emailResponseTime: emailResponseTimeDefaultVal,
  retailStoreHoursEvents: [],
  pageName: '',
};
Object.freeze(HelpCenterComponentDefaults);
export default HelpCenterComponentDefaults;